import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';

const modalRoot = document.getElementById('modal') || document.body;
const el = document.createElement('div');

const Modal = ({
   isOpen,
   children,
   onClose,
   title = 'Modal',
   description,
   actions,
   width = 700,
   height = '80vh',
}) => {
   useEffect(() => {
      modalRoot.appendChild(el);
      return () => {
         if (modalRoot.contains(el)) {
            modalRoot.removeChild(el);
         }
      };
   }, []);

   useEffect(() => {
      const handleEscape = (e) => {
         if (e.key === 'Escape' && isOpen) onClose();
      };
      document.addEventListener('keydown', handleEscape);
      return () => document.removeEventListener('keydown', handleEscape);
   }, [isOpen, onClose]);

   if (!isOpen) return null;

   return createPortal(
      <div
         className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm"
         role="dialog"
         aria-modal="true"
         aria-labelledby="modal-title">
         <div
            className="bg-white dark:bg-zinc-900 rounded-2xl shadow-xl overflow-hidden flex flex-col"
            style={{ width, height }}>
            {/* Header */}
            <div className="flex items-start justify-between p-4 border-b border-gray-200 dark:border-zinc-700">
               <div>
                  <h2
                     id="modal-title"
                     className="text-lg font-semibold text-gray-900 dark:text-white">
                     {title}
                  </h2>
                  {description && (
                     <p className="text-sm text-gray-500 dark:text-gray-400">
                        {description}
                     </p>
                  )}
               </div>
               <button
                  onClick={onClose}
                  className="text-gray-400 hover:text-gray-600 dark:hover:text-white transition"
                  aria-label="Cerrar modal">
                  <svg
                     xmlns="http://www.w3.org/2000/svg"
                     className="h-5 w-5"
                     fill="none"
                     viewBox="0 0 24 24"
                     stroke="currentColor">
                     <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M6 18L18 6M6 6l12 12"
                     />
                  </svg>
               </button>
            </div>

            {/* Content */}
            <div className="flex-1 overflow-auto p-4">{children}</div>

            {/* Footer / Actions */}
            {actions && (
               <div className="flex justify-end gap-2 p-4 border-t border-gray-200 dark:border-zinc-700">
                  {actions}
               </div>
            )}
         </div>
      </div>,
      el,
   );
};

export default Modal;
